import s3URL from '@mathflat/common/util/s3'
import type { ReactNode } from 'react'

import type { StyleProps } from '@/types'

import S from './Loader.style'

type Props = {
  width?: number
  hasText?: boolean
  content?: ReactNode
  theme?: 'primary' | 'white'
} & StyleProps

const Loader = ({
  width,
  hasText = false,
  theme = 'primary',
  className,
  style,
  content = '잠시만 기다려주세요.',
}: Props) => {
  return (
    <div className={className} style={style} css={S.wrapper}>
      <img
        css={S.img}
        style={{ width, height: width }}
        src={s3URL.mathflatAssetsBucket.common(
          `images/${theme === 'primary' ? 'spin' : 'spin-white'}.gif`,
        )}
        alt="로딩"
      />
      {hasText && <p css={S.text}>{content}</p>}
    </div>
  )
}

export default Loader
